import * as React from "react";
import {
  List, Datagrid, TextField, NumberField,
  Show, TabbedShowLayout, ReferenceManyField, Pagination,
  useListContext,
} from "react-admin";
import { Alert } from "@mui/material";
import { JsonField } from "../../components/JsonField";
import { FrDateField } from "../../components/FrDateField";
import { UserRefField } from "../../components/ui";
import { PatientReferenceInput, ProReferenceInput } from "../../components/RelationAutocomplete";

// Backend : GET /follow-up/programs?patientId=… (patientId OBLIGATOIRE),
// GET /follow-up/programs/{id}, GET /follow-up/programs/{id}/entries.
// Point d'entrée principal : fiche patient → onglet « Suivi ».
// Création / modification : depuis l'app (PATCH côté backend, DTO métier).

const filters = [
  <PatientReferenceInput key="patientId" source="patientId" label="Patient" alwaysOn />,
  <ProReferenceInput key="proId" source="proId" label="Professionnel" />,
];

const PatientHint = () => {
  const { filterValues } = useListContext();
  if (filterValues?.patientId) return null;
  return (
    <Alert severity="info" sx={{ m: 2 }}>
      Renseignez l'ID d'un patient (ou ouvrez sa fiche → onglet « Suivi ») pour afficher ses programmes.
    </Alert>
  );
};

export const FollowUpProgramGrid = (props) => (
  <Datagrid rowClick="show" bulkActionButtons={false} {...props}>
    <TextField source="title" label="Titre" />
    <TextField source="type" label="Type" />
    <TextField source="status" label="Statut" />
    <UserRefField source="proId" label="Professionnel" />
    <FrDateField source="startDate" label="Début" />
    <FrDateField source="endDate" label="Fin" />
    <FrDateField source="createdAt" label="Créé le" showTime />
  </Datagrid>
);

export default {
  list: () => (
    <List filters={filters} empty={false} perPage={25}>
      <PatientHint />
      <FollowUpProgramGrid />
    </List>
  ),
  show: () => (
    <Show>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="Détails">
          <TextField source="title" label="Titre" />
          <TextField source="type" label="Type" />
          <TextField source="status" label="Statut" />
          <TextField source="goal" label="Objectif" />
          <TextField source="description" />
          <UserRefField source="patientId" label="Patient" />
          <UserRefField source="proId" label="Professionnel" />
          <NumberField locales="fr-FR" source="durationWeeks" label="Durée (semaines)" />
          <NumberField locales="fr-FR" source="frequencyPerWeek" label="Fréquence / semaine" />
          <FrDateField source="startDate" label="Début" />
          <FrDateField source="endDate" label="Fin" />
          <FrDateField source="createdAt" label="Créé le" showTime />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Entrées">
          <ReferenceManyField
            reference="follow-up-entries"
            target="programId"
            label=""
            perPage={20}
            pagination={<Pagination />}
          >
            <Datagrid bulkActionButtons={false} rowClick={false}>
              <FrDateField source="date" label="Date" />
              <TextField source="value" label="Valeur" />
              <NumberField locales="fr-FR" source="painScore" label="Douleur" />
              <NumberField locales="fr-FR" source="moodScore" label="Humeur" />
              <NumberField locales="fr-FR" source="energyScore" label="Énergie" />
              <TextField source="note" label="Note" />
            </Datagrid>
          </ReferenceManyField>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Brut">
          <JsonField source="__all__" />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  ),
};
